import { api } from '../../shared/api/client';
import { adaptReview } from '../../shared/api/adapters';
import type { ApiReview } from '../../shared/types/api';
import type { Review } from '../../shared/types/app';

export async function fetchReviewByRequest(requestId: string): Promise<Review | null> {
  const res = await api.get<ApiReview | ApiReview[] | { data: ApiReview[] }>(`/api/v1/reviews/request/${requestId}`);
  if (Array.isArray(res)) return res.length > 0 ? adaptReview(res[0]) : null;
  if ('data' in res) return res.data.length > 0 ? adaptReview(res.data[0]) : null;
  return adaptReview(res as ApiReview);
}

export async function fetchApprovedReviews(limit = 3): Promise<Review[]> {
  const res = await api.get<ApiReview[]>(`/api/v1/reviews/approved?limit=${limit}`);
  return res.map(adaptReview);
}

export async function createReview(
  requestId: string,
  payload: { revieweeId: string; rating: number; comment?: string },
): Promise<Review> {
  const res = await api.post<ApiReview>(`/api/v1/reviews/request/${requestId}`, payload);
  return adaptReview(res);
}
